import { Component, ViewEncapsulation, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { AppLanguageSource } from '@app/app-l10n';
import { Locale, LocaleService, TranslationService } from '@fmnts/i18n';
import { DonorDeviceSignalStore } from '@formunauts/self-checkout/data-access';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'verify-wrapper',
  styleUrls: ['../../../next/styles/next.scss', './styles/verify.scss'],
  template: '<router-outlet></router-outlet>',
  standalone: true,
  imports: [RouterModule],
})
export class VerifyComponent {
  private readonly translationService = inject(TranslationService);
  private readonly localeService = inject(LocaleService);

  constructor() {
    const donorDeviceStore = inject(DonorDeviceSignalStore);
    toObservable(donorDeviceStore.languages)
      .pipe(takeUntilDestroyed())
      .subscribe((languages) => {
        this.translationService.setLanguages({
          source: AppLanguageSource.User,
          languages,
        });
      });
    toObservable(donorDeviceStore.locale)
      .pipe(takeUntilDestroyed())
      .subscribe((locale) => {
        this.localeService.setLocaleId(Locale.coerceLegacyLocaleId(locale));
      });
  }
}
